import { useState, useEffect } from 'react';

const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '精选推荐', href: '#cards' },
  { label: '平台特色', href: '#features' },
  { label: '读者评价', href: '#comments' },
  { label: '移动端阅读', href: '#app' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 text-heading text-2xl text-foreground-900 no-underline cursor-pointer"
        >
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-base font-bold">51</span>
          51漫画网
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer bg-transparent border-0 rounded-lg hover:bg-background-100 transition-colors"
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="block px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors no-underline cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}